/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract StorageProof",
                name: "in_storageProof",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "in_dao",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "in_user",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "in_rlpStorageProof",
                type: "bytes",
            },
        ],
        name: "canVoteOnPoll",
        outputs: [
            {
                internalType: "uint256",
                name: "out_weight",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
        ],
        name: "onPollClosed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "in_data",
                type: "bytes",
            },
        ],
        name: "onPollCreated",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
        ],
        name: "onPollDestroyed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class StorageProofACL__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(in_storageProof, overrides) {
        return super.getDeployTransaction(in_storageProof, overrides || {});
    }
    deploy(in_storageProof, overrides) {
        return super.deploy(in_storageProof, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
StorageProofACL__factory.bytecode = _bytecode;
StorageProofACL__factory.abi = _abi;
//# sourceMappingURL=StorageProofACL__factory.js.map